import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalEventDispatcher,
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  rabattstufeReducer,
} from '@ps20-frontend/reducers';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { IAppState } from './appState';
import { rootSaga } from './sagas/rootSaga';

import { rootReducer } from './reducers/rootReducer.reducer';
import { INITIAL_STATE } from './initialState';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { unfVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { vpReducer } from './reducers/vp.reducer';
import { angebotsIdReducer } from './reducers/angebotsId.reducer';
import { unfProduktReducer } from './reducers/unfProdukt.reducer';
import { unfTaasInfoReducer } from './reducers/unfTaasInfo.reducer';
import { vermittlerReducer } from './reducers/vermittler.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  angebotsId: angebotsIdReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  vp: vpReducer,
  antragsnummer: antragsnummerReducer,
  transientState: transientStateReducer,
  produkt: unfProduktReducer,
  vertragsoptionen: unfVertragsoptionenReducer,
  jahresbeitrag: jahresbeitragReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.UNF),
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  taasInfo: unfTaasInfoReducer,
  rabattstufe: rabattstufeReducer,
  vermittler: vermittlerReducer,
});

export function unfStoreFactory(storeIndex: number): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.UNF);
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension(`unf-angebot-gui-${storeIndex}`),
    preloadedState: INITIAL_STATE,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });

  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

// Refactor
GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return (window as unknown as Record<string, unknown>)['globalEventDispatcher'] as GlobalEventDispatcher;
};
